<div class="template-breadcrumb-bar">
  @if (!isCreateCampaign) {
    <div class="breadcrumb-row">
      <div class="breadcrumb-section">
        <a class="text-link" href [routerLink]="'/campaigns/templates'">
          <span class="breadcrumb-item-text clickable">{{ "breadcrumb.label-templates" | translate | uppercase }}</span>
        </a>
      </div>
      <div class="breadcrumb-section">
        <i class="material-icons arrow-icon">arrow_forward_ios</i>
        @if (!isTemplateNew) {
          <span class="breadcrumb-item-text clickable">
            {{ currentItemText !== undefined ? (currentItemText !== "" ? currentItemText : ("breadcrumb.label-new-template" | translate)) : "" }}
          </span>
        }
        @if (isTemplateNew) {
          <span class="breadcrumb-item-text">
            {{ "people.new.title" | translate }}
          </span>
        }
      </div>
    </div>
  }

  @if (isCreateCampaign) {
    <div class="breadcrumb-row">
      <div class="breadcrumb-section">
        @if (accountName) {
          <div class="breadcrumb-section">
            <span class="breadcrumb-item-text">{{ accountName }}</span>
            <i class="material-icons arrow-icon">arrow_forward_ios</i>
          </div>
        }
        @if (isAbTest) {
          <a class="text-link" href [routerLink]="'/campaigns/ab-tests'">
            <span class="breadcrumb-item-text clickable">{{ "breadcrumb.label-ab-tests" | translate | uppercase }}</span>
          </a>
        }
        @if (!isAbTest) {
          <a class="text-link" href [routerLink]="'/campaigns'">
            <span class="breadcrumb-item-text clickable">{{ "breadcrumb.label-campaigns" | translate | uppercase }}</span>
          </a>
        }
      </div>
      <div class="breadcrumb-section">
        <i class="material-icons arrow-icon">arrow_forward_ios</i>
        <span class="breadcrumb-item-text">{{ "generic.create" | translate | uppercase }}</span>
      </div>
    </div>
  }
</div>
